import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import StudentPageTransition from "@/components/StudentPageTransition";
import { SectionErrorBoundary } from "@/components/SectionErrorBoundary";
import {
  StudentApp, StudentLogin, StudentOnboarding, StudentResetPassword, StudentTokenReset,
  StudentWorkout, StudentWorkouts, StudentHistory, StudentChat,
  StudentMessages, StudentInstall, StudentMyProfile, StudentEvolution,
  StudentCheckin, StudentMealPlan, StudentNutritionQuestionnaire, NotFound,
} from "./lazyPages";

export default function StudentRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <StudentPageTransition transitionKey={location.pathname}>
        <Routes location={location}>
          <Route index element={<SectionErrorBoundary section="Home"><StudentApp /></SectionErrorBoundary>} />
          <Route path="login" element={<StudentLogin />} />
          <Route path="onboarding" element={<SectionErrorBoundary section="Onboarding"><StudentOnboarding /></SectionErrorBoundary>} />
          <Route path="redefinir-senha" element={<StudentResetPassword />} />
          <Route path="reset" element={<StudentTokenReset />} />
          <Route path="treinos" element={<SectionErrorBoundary section="Treinos"><StudentWorkouts /></SectionErrorBoundary>} />
          <Route path="treino/:workoutId" element={<SectionErrorBoundary section="Treino"><StudentWorkout /></SectionErrorBoundary>} />
          <Route path="historico" element={<SectionErrorBoundary section="Histórico"><StudentHistory /></SectionErrorBoundary>} />
          <Route path="chat" element={<SectionErrorBoundary section="Chat IA"><StudentChat /></SectionErrorBoundary>} />
          <Route path="mensagens" element={<SectionErrorBoundary section="Mensagens"><StudentMessages /></SectionErrorBoundary>} />
          <Route path="instalar" element={<StudentInstall />} />
          <Route path="perfil" element={<SectionErrorBoundary section="Perfil"><StudentMyProfile /></SectionErrorBoundary>} />
          <Route path="evolucao" element={<SectionErrorBoundary section="Evolução"><StudentEvolution /></SectionErrorBoundary>} />
          <Route path="checkin" element={<SectionErrorBoundary section="Check-in"><StudentCheckin /></SectionErrorBoundary>} />
          <Route path="nutricao" element={<SectionErrorBoundary section="Nutrição"><StudentMealPlan /></SectionErrorBoundary>} />
          <Route path="nutricao/questionario" element={<SectionErrorBoundary section="Questionário"><StudentNutritionQuestionnaire /></SectionErrorBoundary>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </StudentPageTransition>
    </AnimatePresence>
  );
}
